module.exports = __webpack_public_path__ + "img/icon_2.16ae2ad0.svg";